import omnipayLogo from '../../assets/images/omni-pay.png';
import datmanLogo from '../../assets/images/datman.png';

export const ResellerLogoMap = {
    1: omnipayLogo,
    2: datmanLogo
};
